import { Request, BaseApiUrl } from "./api";
// 合同模块
// 列表
export const getSaleContractListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/SaleContract/get`, { params: params });
};
//编辑
export const editSaleContract = (params) => {
  return Request.post(`${BaseApiUrl}/api/SaleContract/put`, params);
};
//新增
export const addSaleContract = (params) => {
  return Request.post(`${BaseApiUrl}/api/SaleContract/post`, params);
};
//批量删除
export const batchDeleteSaleContract = (params) => {
  return Request.post(`${BaseApiUrl}/api/SaleContract/BatchDelete`, params);
};
// export const batchDeleteSaleContract = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/SaleContract/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
// 根据客户ID获取工程列表
export const getProjectByClientPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Project/GetProjectByClient`, {
    params: params,
  });
};
// 根据合同ID获取合同详情
export const getSaleContractDetailPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/SaleContract/Detail`, {
    params: params,
  });
};

// 根据合同ID获取合同详情
export const getFile = (params) => {
  return Request({
    url: `${BaseApiUrl}/api/Upload/DownBmd`,
    method: "get",
    params: params,
    onDownloadProgress: (p) => {
      // this.precent = Math.floor(100 * (p.loaded / p.total))
    },
    responseType: "blob",
  });
};

//归档
export const filedInfo = (params) => {
  return Request.post(`${BaseApiUrl}/api/SaleContract/FiledInfo`, params);
};
// 历史列表
export const getHistryByPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/SaleContract/GetHistry`, { params: params });
};

// 根据获取合同或者工程信息作为建立任务单的基础信息
export const getSelectListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/SaleContract/GetSelect`, { params: params });
};
